import React, {Component} from "react";
import {PostPaymentItem} from "../item/PostPaymentItem";
import {PaymentResult} from "../../../../../stripe/model/PaymentResult";
import {StripeErrorMapper} from "../../../../../stripe/util/StripeErrorMapper";

interface Props {
    result: PaymentResult;
}

export class PostPaymentHeader extends Component<Props> {
    render() {
        let result = this.props.result;
        return <PostPaymentItem>
                    <span>
                        <h3>{this.headerText(result)}</h3>
                    </span>
        </PostPaymentItem>;
    }

    private headerText = (result: PaymentResult): string => {
        if (result.paid === true) {
            return 'Huzzah! Your payment is complete!';
        }
        if (result.paid === null || this.isPending(result)) {
            return 'Please wait a few minutes while we process your payment.';
        }
       return StripeErrorMapper.mapAchFailureCode(result.failureCode, result.failureMessage);
    };

    private isPending = (result: PaymentResult): boolean => {
        if (result.paid === null) {
            return true;
        }
        const hasFailureMessage = result.failureMessage != null && result.failureMessage.length > 0;
        const hasFailureCode = result.failureCode != null && result.failureCode.length > 0;
        const hasErrorParams = result.errorParams != null;
        return !result.paid && !hasFailureMessage && !hasFailureCode && !hasErrorParams;
    };
}
